<template>
  <span class="highlight-template">
    <div v-if="visible">
      <div
        class=""
        v-html="flashcardTemplate"
      >
      </div>
      <template
        v-for="(item, index) in choices"
        :key="item.id"
      >
        <span
          :id="choiceIdentifier(index + 1)"
        >
          <span
            :class="indicatorClass(item)"
          />
          <span
            :class="setClasses(item)"
            @click="handleChoiceClick(item)"
            v-html="item.content"
          />
        </span>
      </template>
    </div>
  </span>
</template>

<script>
import HighlightFlashcardMixin from '@/mixins/highlightFlashcard';

export default {
  mixins: [HighlightFlashcardMixin],
  props: {
    answered: {
      type: Boolean,
    },
    answerIds: {
      type: Array,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
    flashcardState: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    indicatorKey(item) {
      return `indicator-${item.id}`;
    },
    indicatorClass(item) {
      let style = {};
      let highlightCheckmarkIncorrect = false;
      let highlightCheckmarkCorrect = false;
      if( this.answered ) {
        if( item.correct ) {
          highlightCheckmarkCorrect = true;
        } else {
          if( item.selected ) {
            highlightCheckmarkIncorrect = true;
          }
        }
      }
      style = {
        'highlight-checkmark-incorrect': highlightCheckmarkIncorrect,
        'highlight-checkmark-correct': highlightCheckmarkCorrect,
      };
      return style;
    },
    setClasses(item) {
      let style;
      let highlightGreen = false;
      let highlightRed = false;

      if( this.answered ) {
        if(item.selected ) {
          if( item.correct ) {
            highlightGreen = true;
          } else {
            highlightRed = true;
          }
        }
        style = {
          'highlight-locked': true,
          'highlight-red': highlightRed,
          'highlight-green': highlightGreen,
        };
      } else {
        style = {
          highlight: true,
          selected: item.selected,
        };
      }
      return style;
    },
  },
};
</script>

<style lang='scss'>
  .highlight-template {
    line-height: 1.75em;

    .highlight {
      background-color: #ffffff;
      color: #000000;
      cursor: pointer;
    }
    .highlight:hover {
      background-color: RGBA(0, 0, 0, 0.1) !important;
    }
    .selected {
      background-color: RGBA(0, 216, 248, 0.1) !important;
    }
    .highlight-bar, .bar {
      width: 1px;
      height: 0.75em;
      padding: 2px;
      background-color: #00D8F8;
      margin: 2px;
    }

    span.highlight p {
      display: inline;
    }

    .highlight-locked p {
      display: inline;
    }

    .highlight-checkmark-correct {
        display:inline-block;
        width: 22px;
        height:22px;
        background: #66bb6a;
        border-radius:50%;
        -ms-transform: rotate(45deg); /* IE 9 */
        -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
        transform: rotate(45deg) translate(4px, 4px);
        margin-right: 5px;
    }

    .highlight-checkmark-correct:before{
        content:"";
        position: absolute;
        width: 3px;
        height: 9px;
        background-color: #fff;
        left: 11px;
        top: 6px;
    }

    .highlight-checkmark-correct:after{
        content: "";
        position: absolute;
        width: 3px;
        height: 3px;
        background-color: #fff;
        left: 8px;
        top: 12px;
    }

    .highlight-checkmark-incorrect::before {
      content: "X";
    }
    .highlight-checkmark-incorrect {
      margin-right: 5px;
      display: inline-block;
      width: 22px;
      line-height: 22px;
      border-radius: 50%;
      font-size: 14px;
      color: white;
      background-color: red;
      font-weight: bold;
      font-family: verdana;
      text-align: center;
    }

    .highlight-green {
      background-color: #D9F4E9;
      padding: 0 4px 0 4px;
    }

    .highlight-red {
      background-color: #FAE1DC;
      padding: 0 4px 0 4px;
    }
  }
</style>
